module.exports = __webpack_public_path__ + "img/592-_TURTLEBotan.55996972.png";